import { Context, useContext as useContextBase } from 'react';

export const useContext = <T>(context: Context<T | undefined>) => {
  const ctx = useContextBase(context);
  if (!ctx) {
    throw new Error(
      `useContext must be inside a Provider with a value (${context.displayName})`,
    );
  }
  return ctx;
};
